/* eslint-disable no-unused-vars */
/* eslint-disable max-len */
import React from 'react';
import PropTypes from 'prop-types';
import styles from './shared-styles';

const ThirdRowSeat = ({ height, width, color, className, secondaryColor, ...props }) => (
  <span css={styles} className={className}>
    <svg viewBox="0 0 24 26" height={height} width={width} {...props} xmlns="http://www.w3.org/2000/svg">
      <g fill={color}>
        <g fillRule="nonzero"><path d="M17.77 11.45c1.94 0 3.23-1.15 3.23-2.75a2.51 2.51 0 0 0-1.7-2.28 2.37 2.37 0 0 0 1.45-2.18 2.72 2.72 0 0 0-3-2.58 3.36 3.36 0 0 0-2.64 1.24.24.24 0 0 0 0 .37l.68.65a.26.26 0 0 0 .38 0 1.83 1.83 0 0 1 1.42-.67A1.32 1.32 0 0 1 19 4.47c0 .72-.59 1.28-1.75 1.28h-.79c-.16 0-.26.1-.26.29v.89a.25.25 0 0 0 .26.27h.79c1.27 0 1.94.55 1.94 1.45a1.36 1.36 0 0 1-1.49 1.27 2.25 2.25 0 0 1-1.73-.77.25.25 0 0 0-.36 0l-.72.7a.3.3 0 0 0 0 .36 3.73 3.73 0 0 0 2.88 1.24zM23.06 19.49a2.46 2.46 0 0 0-2.35-.7c-2.4.25-7.86 1.39-10.81 2v-.09C12 16.26 8.41 11 6.7 8.49a11.86 11.86 0 0 1-.76-1.18C5.35 6.08 4.72 5.2 3.7 5h-.44c.14-.39.26-.66.38-.66.35 0 .5-.1.64-.59S3 1 3 1A2 2 0 0 0 .59.7c-.3.38 1.83 6.79 1.83 6.79l2.85 12.39a2.06 2.06 0 0 0-.21 1.57l1.23 3.83a.43.43 0 0 0 .41.3h15a.43.43 0 0 0 .41-.29l.89-2.58v-.06c.22-.54.83-2.17.06-3.16z" /></g>
      </g>
    </svg>
  </span>
);

ThirdRowSeat.propTypes = {
  height: PropTypes.number,
  width: PropTypes.number,
  color: PropTypes.string,
  className: PropTypes.string,
  secondaryColor: PropTypes.string
};

ThirdRowSeat.defaultProps = {
  height: 25,
  width: 25,
  color: 'currentColor',
  className: '',
  secondaryColor: 'currentColor'
};

export default ThirdRowSeat;
